{
    "NAME": "Configurações de registro Idioma",
    "LoggingSettings_Column_Component": "Componente",
    "LoggingSettings_Column_Enabled": "Habilitado",
    "LoggingSettings_Column_BackupLogs": "Registros de backup",
    "LoggingSettings_Column_Level": "Nível",
    "LoggingSettings_Column_RollOverFiles": "Arquivos de rollover",
    "LoggingSettings_Column_MaxFileSizeAsMB": "Tamanho máximo do arquivo (MB)",
    "LoggingSettings_Component_MainServlet": "Servlet principal",
    "LoggingSettings_Component_Database": "Banco de dados",
    "LoggingSettings_Component_Repository": "Repositório",
    "LoggingSettings_Component_RptExecMgr": "Gerente de Execução de Relatórios",
    "LoggingSettings_Component_MailController": "Controlador de Correio",
    "LoggingSettings_Component_TaskDelegator": "Delegador de Tarefas",
    "LoggingSettings_Component_TelephoneModule": "Módulo Telefônico",
    "LoggingSettings_Component_OmniModule": "Módulo Omnicanal",
    "LoggingSettings_Action_Save": "Salvar",
    "LoggingSettings_Action_Cancel": "Cancelar",
    "LoggingSettings_Action_Refresh": "Atualizar",
    "LoggingSettings_ReadOnlyWarning": "Você não possui privilégios de administrador global para atualizar as configurações de registro.",
    "LoggingSettings_SaveSuccess": "As configurações de registro foram salvas.",
    "LoggingSettings_SaveError": "Não foi possível salvar as configurações de registro.",
    "LoggingSettings_RefreshConfirmTitle": "Descartar alterações não salvas?",
    "LoggingSettings_RefreshConfirmBody": "A atualização descartará as alterações não salvas. Deseja continuar?",
    "LoggingSettings_Empty": "Não há configurações de registro disponíveis."
}